import * as React from "react";
import { DataGridPro, GridColumns, GridSelectionModel } from "@mui/x-data-grid-pro";
import { addCustomDataGridFilters } from "../../../../../components/common/customDataGridFilters/customDataGridFilters";
import { AssessmentListItem } from "../../../../../services/types/sessionDetailTypes";
import CclDataGridToolbar from "../../../../../components/common/cclDataGridToolbar/cclDataGridToolbar";
import { UserClaimsService } from "../../../../../services/currentUserService/currentUserService";

export interface SessionAssessmentsSetupTableProps {
    AssessmentList: AssessmentListItem[] | undefined;
    isLoading: boolean;
    handleEvent: (evt: string, ids: number[]) => void;
    readOnly?: boolean;
    functionInProgress: string;
}

const SessionAssessmentsSetupTable: React.FC<SessionAssessmentsSetupTableProps> = (props) => {
    const [selectedIds, setSelectedIds] = React.useState<number[]>([]);
    const [selectedIdIsDocument, setSelectedIdIsDocument] = React.useState<boolean>(false);
    const showToolbar = props.handleEvent !== undefined && !props.readOnly;
    const claimsService = new UserClaimsService();
    const isNwaAdmin = claimsService.IsUserNwaAdmin();

    React.useEffect(() => {
        setSelectedIds([]);
    }, [props.AssessmentList]);

    const COLUMNS = [
        {
            field: "cclMasterKey",
            headerName: "ID",
            type: "string",
            width: 150,
        },
        {
            field: "assessmentType",
            headerName: "Type",
            type: "string",
            width: 150,
        },
        {
            field: "title",
            headerName: "Title",
            flex: 1,
            type: "string",
        },
    ];

    return (
        <DataGridPro
            getRowId={(row) => row.cclMasterKey}
            rows={props.AssessmentList ?? []}
            columns={addCustomDataGridFilters(COLUMNS as GridColumns<any>)}
            loading={props.isLoading}
            initialState={{ sorting: { sortModel: [{ field: "title", sort: "asc" }] } }}
            components={{ Toolbar: CclDataGridToolbar }}
            componentsProps={
                showToolbar
                    ? {
                          toolbar: {
                              miscButtons: [
                                  {
                                      id: "addAssessment",
                                      caption: "Add Assessment(s)",
                                      label: "Add Assessment(s)",
                                      disable: props.isLoading,
                                  },
                                  ...(!isNwaAdmin
                                      ? [
                                            {
                                                id: "addDocument",
                                                caption: "Add Document(s)",
                                                label: "Add Document(s)",
                                                disable: props.isLoading,
                                            },
                                            {
                                                id: "view",
                                                caption: "Download Document",
                                                label: "Download Document",
                                                disable:
                                                    selectedIds.length !== 1 ||
                                                    !selectedIdIsDocument,
                                                loadingBtn: true,
                                                isLoading: props.functionInProgress === "view",
                                            },
                                        ]
                                      : []),
                                  {
                                      id: "remove",
                                      caption: "Remove Item(s)",
                                      label: "Remove Item(s)",
                                      disable: selectedIds.length === 0,
                                  },
                              ],
                              btnClick: (buttonName: string) =>
                                  props.handleEvent(buttonName, selectedIds),
                              showSaveState: false,
                              hideSettingsButtons: true,
                              resultBar: false,
                          },
                      }
                    : {
                          toolbar: {
                              showSaveState: false,
                              hideSettingsButtons: true,
                              resultBar: false,
                          },
                      }
            }
            checkboxSelection={showToolbar}
            onSelectionModelChange={(ids: GridSelectionModel) => {
                const selectedIds = [...ids.map((i) => i as number)];
                setSelectedIds(selectedIds);
                setSelectedIdIsDocument(
                    selectedIds.length === 1 &&
                        props.AssessmentList?.find((a) => a.cclMasterKey === selectedIds[0])
                            ?.instrumentTypeKey === 0,
                );
            }}
            isCellEditable={(params) => params.row.groupReportAvailable === true}
            autoHeight
        />
    );
};

export default SessionAssessmentsSetupTable;
